export const NODE_WIDTH = 200;
export const NODE_HEIGHT = 50;
export const PADDING = 50;

export type Employee = {
  id: string;
  name: string;
  role: string;
  email: string;
  profilePhoto: string;
  mentees: number;
  mentorMatch: string;
  children?: Employee[];
};

export const sampleOrgData: Employee = {
  id: '1',
  name: 'Helen Mirren',
  role: 'Head of People and Culture',
  email: 'helen.mirren@abc.co',
  profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50701/2023/01/06/50701.jpg_1673027582998',
  mentees: 4,
  mentorMatch: 'Low (40%)',
  children: [
    {
      id: '2',
      name: 'Sibley Bourn',
      role: 'Engineering Manager',
      email: 'sibley.bourn@abc.co',
      profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50695/2023/01/06/50695.jpg_1673027621626',
      mentees: 5,
      mentorMatch: 'High (80%)',
      children: [
        {
          id: '3',
          name: 'Troy Carpenter',
          role: 'Software Architect',
          email: 'troy.carpenter@abc.co',
          profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50712/2023/01/06/50712.jpg_1673027629546',
          mentees: 3,
          mentorMatch: 'Medium (75%)',
          children: [
            {
              id: '4',
              name: 'Bruce Salem',
              role: 'BackEnd Engineer',
              email: 'bruce.salem@abc.co',
              profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50724/2023/01/06/50724.jpg_1673027627036',
              mentees: 5,
              mentorMatch: 'High (95%)',
            },
          ],
        },
        {
          id: '5',
          name: 'Chloe Nunez',
          role: 'iOS Developer',
          email: 'chloe.nunez@abc.co',
          profilePhoto: 'https://media.mesh.ai/2415/media/profilePhoto/50721/2023/01/06/50721.jpg_1673027588228',
          mentees: 2,
          mentorMatch: 'Low (20%)',
        },
      ],
    },
  ],
};
